import request from '@/utils/request'

export function getSHManageData (params, isProgress) {
  return request({
    url: `/api/getSHManageData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    data: params,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

export function getSHSampleData (params, isProgress) {
  return request({
    url: `/api/getSHSampleData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

export function saveSHManageData (params, isProgress) {
  return request({
    url: `/api/saveSHManageData`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' },
  })
}

export function getSHManageDataReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: `/api/getSHManageDataReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

export function getSHManagePolicyComment (params, isProgress) {
  return request({
    url: `/api/getSHManagePolicyComment`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}

